---
import { MdPlayCircleOutline } from 'react-icons/md';

import { clsx } from '@digital-spiders/misc-utils';
import type { Mark, Props as PortableTextProps } from 'astro-portabletext/types';
import { VIDEO_TYPES_MAP } from '../../constants';
import TextLink from '../ui/TextLink';
import styles from './GenericLinkSerializer.module.scss';
import { spanToPlainText } from 'astro-portabletext';

type Props = PortableTextProps<Mark<{ url: string }>>;

const { node } = Astro.props;

const linkText = spanToPlainText(node);
let linkSizeClass = styles.smallLink;
if (linkText.length > 20) {
  linkSizeClass = styles.mediumLink;
}
if (linkText.length > 60) {
  linkSizeClass = styles.largeLink;
}

const isVideo = !!Object.values(VIDEO_TYPES_MAP).find(({ formatRegex }) =>
  node.markDef.url.match(formatRegex),
)?.type;
---

{
  isVideo ? (
    <TextLink
      styleOnly
      className={clsx(styles.link, linkSizeClass, styles.inlineVideo)}
      data-url={node.markDef.url}
    >
      <MdPlayCircleOutline aria-label="video-play" />
      <slot />
    </TextLink>
  ) : (
    <TextLink to={node.markDef.url} className={clsx(styles.link, linkSizeClass)}>
      <slot />
    </TextLink>
  )
}

<script>
  import { openEmbedVideoModal } from '../../stores/embedVideoModalStore';
  import * as styles from './GenericLinkSerializer.module.scss';

  const inlineVideos = document.querySelectorAll<HTMLElement>('.' + styles.inlineVideo);
  for (const inlineVideo of inlineVideos) {
    const videoUrl = inlineVideo.getAttribute('data-url')!;
    inlineVideo.addEventListener('click', () => {
      openEmbedVideoModal({
        embedVideoUrl: videoUrl,
      });
    });
  }
</script>
